import { Workbook } from 'exceljs';
import { download } from '../download';
import { TableService } from './service';
import type * as Types from './types';

export async function downloadTable<T>(params: Types.DownloadParams<T>): Promise<void> {
  const { fileName, sheets } = params;

  const workbook = new Workbook();
  const service = new TableService();

  for (const sheet of sheets) {
    const { manual, custom, sheetName, columns } = sheet;

    if (manual === true) {
      continue;
    }
    const worksheet = workbook.addWorksheet(sheetName ?? fileName);
    // 自定义表格
    if (custom === true) {
      const { rows, mergeCellOptions } = sheet as Types.CustomSheet;
      worksheet.columns = columns as Types.ExcelColumns;
      worksheet.addRows(rows);
      if (Array.isArray(mergeCellOptions)) {
        for (const options of mergeCellOptions) {
          worksheet.mergeCells(options);
        }
      }
    } else {
      const { dataSource } = sheet;
      let dataIndexKey = '';

      worksheet.columns = columns.map(col => {
        if (Array.isArray(col.dataIndex)) {
          const [key = '', value = ''] = col.dataIndex as string[];
          dataIndexKey = key;
          return {
            header: String(col.title),
            key: `${key}_${value}`,
            width: 20,
            style: {
              numFmt: col?.numFmt ?? '' // 下载Excel内的单元格格式
            }
          };
        }
        return {
          header: String(col.title),
          key: String(col.dataIndex),
          width: 20,
          style: {
            numFmt: col?.numFmt ?? '' // 下载Excel内的单元格格式
          }
        };
      });
      worksheet.addRows(dataIndexKey === '' ? dataSource : service.transformTableData<T>(dataSource, dataIndexKey));
    }
    if (sheet.eachRow != null) {
      worksheet.eachRow({ includeEmpty: false }, sheet.eachRow);
    }
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer]);

  await download({ type: 'blob', blob, fileName: `${fileName}.xlsx` });
}

